/* Dekozen (Athora) image-lookbook -> Concept portu. Bagimsiz vanilla JS.
   Kaynak davranis: global.js TabPlayerList (sekme + otomatik oynatma) ve custom.js MediaLookbook (gecis animasyonu, hover'da durdurma, editor destegi).
   Tema global'i kullanilmaz. */
(function () {
  'use strict';
  if (customElements.get('dkz-image-lookbook')) return;

  var DESKTOP_MQ = '(min-width: 768px)';

  function DkzImageLookbook() {
    return Reflect.construct(HTMLElement, [], DkzImageLookbook);
  }
  DkzImageLookbook.prototype = Object.create(HTMLElement.prototype, {
    constructor: { value: DkzImageLookbook, writable: true, configurable: true }
  });
  Object.setPrototypeOf(DkzImageLookbook, HTMLElement);

  DkzImageLookbook.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;

    this.classList.add('dkzlb--js');

    this.tabs = Array.prototype.slice.call(this.querySelectorAll('.dkzlb-tab'));
    this.medias = Array.prototype.slice.call(this.querySelectorAll('.dkzlb-media'));
    this.contents = Array.prototype.slice.call(this.querySelectorAll('.dkzlb-content'));
    this.index = 0;

    this.delay = parseInt(this.getAttribute('data-autoplay'), 10) || 0;
    this.remaining = this.delay;
    this._timer = null;
    this._startedAt = 0;
    this._pauseReasons = {};

    this._bindTabs();
    this._bindPins();
    this._bindSliders();
    this._bindHoverPause();
    this._bindVisibility();
    this._observeView();
    this._bindDesignMode();
  };

  DkzImageLookbook.prototype.disconnectedCallback = function () {
    this._clearTimer();
    if (this._io) this._io.disconnect();
  };

  /* ---------- Sekme secimi ---------- */
  DkzImageLookbook.prototype._bindTabs = function () {
    var self = this;
    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (i === self.index) return;
        self.remaining = self.delay;
        self.select(i, true);
        self._restartTimer();
      });
    });
  };

  DkzImageLookbook.prototype.select = function (i, animate) {
    this.index = i;
    this.tabs.forEach(function (tab, j) {
      tab.setAttribute('aria-current', j === i ? 'true' : 'false');
    });
    this.medias.forEach(function (media, j) {
      if (j === i) media.removeAttribute('hidden');
      else media.setAttribute('hidden', '');
      media.classList.remove('dkzlb-anim');
    });
    this.contents.forEach(function (content, j) {
      if (j === i) content.removeAttribute('hidden');
      else content.setAttribute('hidden', '');
      content.classList.remove('dkzlb-anim');
    });
    if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var media = this.medias[i];
      var content = this.contents[i];
      // Animasyonu yeniden tetiklemek icin reflow
      if (media) { void media.offsetWidth; media.classList.add('dkzlb-anim'); }
      if (content) { void content.offsetWidth; content.classList.add('dkzlb-anim'); }
    }
  };

  /* ---------- Otomatik oynatma ---------- */
  DkzImageLookbook.prototype._startTimer = function () {
    if (!this.delay || this.tabs.length < 2) return;
    if (Object.keys(this._pauseReasons).length) return;
    this._clearTimer();
    var self = this;
    this._startedAt = Date.now();
    this.style.setProperty('--dkzlb-play', 'running');
    this._timer = setTimeout(function () {
      self.remaining = self.delay;
      self.select((self.index + 1) % self.tabs.length, true);
      self._startTimer();
    }, this.remaining);
  };

  DkzImageLookbook.prototype._clearTimer = function () {
    if (this._timer) { clearTimeout(this._timer); this._timer = null; }
  };

  DkzImageLookbook.prototype._restartTimer = function () {
    if (!this.delay) return;
    this.remaining = this.delay;
    this._startTimer();
  };

  DkzImageLookbook.prototype._pause = function (reason) {
    if (!this.delay) return;
    if (this._timer) {
      var elapsed = Date.now() - this._startedAt;
      this.remaining = Math.max(200, this.remaining - elapsed);
      this._clearTimer();
    }
    this._pauseReasons[reason] = true;
    this.style.setProperty('--dkzlb-play', 'paused');
  };

  DkzImageLookbook.prototype._resume = function (reason) {
    if (!this.delay) return;
    delete this._pauseReasons[reason];
    if (!Object.keys(this._pauseReasons).length) this._startTimer();
  };

  DkzImageLookbook.prototype._bindHoverPause = function () {
    if (!this.delay) return;
    var self = this;
    ['.dkzlb-media-holder', '.dkzlb-panel'].forEach(function (sel) {
      var el = self.querySelector(sel);
      if (!el) return;
      el.addEventListener('mouseenter', function () { self._pause('hover'); });
      el.addEventListener('mouseleave', function () { self._resume('hover'); });
    });
  };

  DkzImageLookbook.prototype._bindVisibility = function () {
    if (!this.delay) return;
    var self = this;
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self._pause('doc');
      else self._resume('doc');
    });
  };

  /* ---------- Gorunum alani: reveal + otomatik oynatmayi baslat ---------- */
  DkzImageLookbook.prototype._observeView = function () {
    var self = this;
    var revealed = false;
    var reveal = function () {
      if (revealed) return;
      revealed = true;
      self.classList.add('dkzlb-inview');
      self.select(self.index, true);
    };
    if (!('IntersectionObserver' in window)) {
      reveal();
      this._startTimer();
      return;
    }
    this._pauseReasons.view = true;
    this._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal();
          self._resume('view');
        } else {
          self._pause('view');
        }
      });
    }, { threshold: 0.3 });
    this._io.observe(this);
    if (!this.hasAttribute('data-reveal')) {
      // Reveal kapali: icerik gizlenmez, yalnizca autoplay gorunurluge bagli calisir
      revealed = true;
      this.classList.add('dkzlb-inview');
    }
  };

  /* ---------- Pinler (hotspot) ---------- */
  DkzImageLookbook.prototype._bindPins = function () {
    var self = this;
    this.medias.forEach(function (media, mediaIndex) {
      var pins = Array.prototype.slice.call(media.querySelectorAll('.dkzlb-pin-btn'));
      pins.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-pin-index'), 10) || 0;
          if (window.matchMedia(DESKTOP_MQ).matches) {
            // Masaustu: sag paneldeki urun kaydiricisini ilgili urune getir
            var content = self.contents[mediaIndex];
            if (!content) return;
            var slides = content.querySelector('.dkzlb-slides');
            if (slides) slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' });
            self._setActivePin(media, idx);
          } else {
            // Mobil: urun popover'ini ac
            var dialog = document.getElementById(btn.getAttribute('aria-controls'));
            if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
            self._setActivePin(media, idx);
          }
        });
      });

      // Popover kapatma: X butonu + backdrop tiklamasi
      var dialogs = Array.prototype.slice.call(media.querySelectorAll('dialog.dkzlb-popover'));
      dialogs.forEach(function (dialog) {
        var close = dialog.querySelector('.dkzlb-popover-close');
        if (close) close.addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (e) {
          if (e.target === dialog) dialog.close();
        });
      });
    });
  };

  DkzImageLookbook.prototype._setActivePin = function (media, idx) {
    var pins = media.querySelectorAll('.dkzlb-pin-btn');
    Array.prototype.forEach.call(pins, function (btn) {
      var i = parseInt(btn.getAttribute('data-pin-index'), 10) || 0;
      btn.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
  };

  /* ---------- Urun kaydiricisi (sag panel) ---------- */
  DkzImageLookbook.prototype._bindSliders = function () {
    var self = this;
    this.contents.forEach(function (content, contentIndex) {
      var slides = content.querySelector('.dkzlb-slides');
      if (!slides) return;
      var count = parseInt(slides.getAttribute('data-count'), 10) || slides.children.length || 1;
      var nav = content.querySelector('.dkzlb-slider-nav');

      var setProgress = function (index) {
        if (nav) nav.style.setProperty('--dkzlb-scale', String((index + 1) / count));
      };
      setProgress(0);

      var currentIndex = function () {
        var w = slides.clientWidth || 1;
        return Math.max(0, Math.min(count - 1, Math.round(slides.scrollLeft / w)));
      };

      var raf = null;
      slides.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = currentIndex();
          setProgress(idx);
          var media = self.medias[contentIndex];
          if (media) self._setActivePin(media, idx);
        });
      }, { passive: true });

      if (nav) {
        Array.prototype.forEach.call(nav.querySelectorAll('.dkzlb-nav-btn'), function (btn) {
          btn.addEventListener('click', function () {
            var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
            var idx = currentIndex() + dir;
            if (idx < 0) idx = count - 1;
            if (idx > count - 1) idx = 0;
            slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' });
          });
        });
      }
    });
  };

  /* ---------- Tema editoru ---------- */
  DkzImageLookbook.prototype._bindDesignMode = function () {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    var self = this;
    document.addEventListener('shopify:block:select', function (event) {
      var tab = event.target && event.target.closest ? (event.target.classList.contains('dkzlb-tab') ? event.target : event.target.closest('.dkzlb-tab')) : null;
      if (!tab || self.tabs.indexOf(tab) === -1) return;
      self._pause('editor');
      setTimeout(function () {
        var i = self.tabs.indexOf(tab);
        if (i !== -1 && i !== self.index) self.select(i, true);
      }, 20);
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var tab = event.target && event.target.closest ? event.target.closest('.dkzlb-tab') : null;
      if (!tab || self.tabs.indexOf(tab) === -1) return;
      self._resume('editor');
    });
  };

  customElements.define('dkz-image-lookbook', DkzImageLookbook);
})();

/* 29 Agu — mobil gorunum oklari: select() API'sine baglanir, otomatik oynatmayi
   tazeler. Ayri dosya sonuna eklendi ki mevcut prototip govdesi degismesin. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.dkzlb-look-btn');
    if (!btn) return;
    var root = btn.closest('dkz-image-lookbook');
    if (!root || typeof root.select !== 'function' || !root.tabs || !root.tabs.length) return;
    var dir = parseInt(btn.getAttribute('data-look-dir'), 10) || 1;
    var len = root.tabs.length;
    root.select((root.index + dir + len) % len, true);
    if (typeof root._restartTimer === 'function') root._restartTimer();
  });
})();
